export const SOCIAL_LINKS = {
  TELEGRAM: 'https://t.me/ArtemZvir',
  EMAIL: 'mailto:clientcare@zvir.tech',
  INSTAGRAM: 'https://instagram.com/ArtemZvir',
  LK: 'https://lk.zvir.tech',
  PROFI: 'https://profi.ru/profile/ZvirAD'
} as const;

/** Внутренние страницы с текстами из public/docs */
export const INTERNAL_LINKS = {
  PRIVACY: '/privacy',
  OFFER: '/offer',
  TERMS: '/terms',
  COOKIES: '/cookies',
  CONSENT: '/consent',
} as const; 

export const API_BASE_LINK = 'https://api.zvir.tech/api/v1';